import { Card, Flex, P, Table, Td, Tr } from '@dnb/eufemia';
import { ErrorIcon } from '@dnb/eufemia/components/form-status';
import { ServiceNowDigitalIntegrationRequestDto } from '@portals/shared/portal/SupportTicket';
import type { JSX } from 'react';
import useSWR from 'swr';

import styles from './index.module.css';

type DigitalIntegrationRequestDetailsProps = {
  requestId: string;
};
export default function DigitalIntegrationRequestDetails({
  requestId,
}: DigitalIntegrationRequestDetailsProps): JSX.Element {
  const {
    data: request,
    isValidating,
    error,
  } = useSWR<ServiceNowDigitalIntegrationRequestDto>(`/service-now/digital-integration-requests/${requestId}`, {
    onError: () => {},
  });
  return (
    <Card
      filled
      innerSpace={0}
      responsive={false}
      skeleton={isValidating}
      title={
        <>
          <b>Ticket Id: </b>
          {requestId}
        </>
      }
    >
      {error && (
        <Card className={styles['ErrorCard']}>
          <Flex.Container align="center" gap="small">
            <ErrorIcon />
            <P>Failed to load approval details</P>
          </Flex.Container>
        </Card>
      )}
      {request && (
        <Table.ScrollView>
          <Table border outline size="medium">
            <tbody>
              {request.approvals.map((approval) => (
                <Tr key={approval.userName}>
                  <Td>
                    <P>
                      {approval.name} ({approval.email})
                    </P>
                    Status: {approval.state}
                  </Td>
                </Tr>
              ))}
            </tbody>
          </Table>
        </Table.ScrollView>
      )}
    </Card>
  );
}
